import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class RegistrationWithPersonalNumberConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getPersonalNumberVerificationEndpoint(): string {
		return this.service.get(
			(x) => x.common.registrationWithPersonalNumber.endpoints!.personalNumberVerification,
			"v1/se/personalnumber/:personalNumber"
		);
	}
}
